'use strict';

var _ = require('underscore');

export default {

  trackEvent: function (category, action, label) {
    if (window.ga) {
      window.ga('send', 'event', category, action, label);

      if (window.SETTINGS && window.SETTINGS.universal_ga_code != null) {
        window.ga('clientTracker.send', 'event', category, action, label);
      }
    }
  },

  trackView: function (title) {
    if (window.ga) {
      window.ga('send', 'pageview', { title });

      if (window.SETTINGS && window.SETTINGS.universal_ga_code != null) {
        window.ga('clientTracker.send', 'pageview', { title });
      }
    }
  },

  getUrlParams() {
    return _.chain(window.location.search.slice(1).split('&'))
      .map((item) => { if (item) { return item.split('='); } return false; })
      .compact()
      .object()
      .value();
  },

  getConversionsDataAndTrack() {
    const urlParams = this.getUrlParams();

    const { google_conversion_id, google_conversion_label } = window.SETTINGS;

    if (urlParams.googleConversionId && urlParams.googleConversionLabel) {
      this.trackConversions(
        urlParams.googleConversionId,
        urlParams.googleConversionLabel,
      );
    } else if (google_conversion_id && google_conversion_label) {
      this.trackConversions(google_conversion_id, google_conversion_label);
    }
  },

  trackConversions(conversionId, conversionLabel) {
    if (window.google_trackConversion && conversionId && conversionLabel) {
      window.google_trackConversion({
        google_conversion_id: conversionId,
        google_conversion_label: conversionLabel,
        google_conversion_format: '3',
        google_remarketing_only: false,
      });
    }
  },
};
